import { useWatchWalletDialog } from './logic/useWatchWalletDialog'
import { WatchWalletDialogView } from './views/WatchWalletDialogView'

export interface WatchWalletDialogContentContainerProps {
  closeDialog: () => void
}

export function WatchWalletDialogContentContainer({ closeDialog }: WatchWalletDialogContentContainerProps) {
  const { enableWatchWalletMode, inputAddressExtension, field } = useWatchWalletDialog(closeDialog)

  return (
    <WatchWalletDialogView
      field={field}
      inputAddressExtension={inputAddressExtension}
      enableWatchWalletMode={enableWatchWalletMode}
    />
  )
}
